import {addScript} from '../../bundles/helpers/add-script';

window.loadInputmask = async () => {
  await addScript(PUBLIC_PATH + 'vendor/inputmask/index.vendor.js');
  await addScript(PUBLIC_PATH + 'vendor/inputmask/extensions.vendor.js');
  await addScript(PUBLIC_PATH + 'vendor/inputmask/date.extensions.vendor.js');
  await addScript(PUBLIC_PATH + 'vendor/inputmask/numeric.extensions.vendor.js');
  window.Block.Inputmask.loaded = true;
}

window.Block = window.Block ? window.Block : {};
window.Block.Inputmask = {
  loaded: null
};

(($) => {
  const target = '[data-inputmask]';

  async function initMask() {
    const targets = $(target).not('.init').addClass('init').toArray();
    if (targets.length) {
      if (!window.Inputmask) await loadInputmask();
      Inputmask().mask(targets);
    }
  }

  $(document)
    .on('OnDocumentHtmlChanged', initMask)
    .on('DOMContentLoaded', initMask)
    .on('ready', initMask);
})($);
